import { action } from 'satcheljs/lib/legacy';
import ComposeViewState from '../store/schema/ComposeViewState';

// Upgrade timer will be cleared when upgrade is complete or compose is closed
export default action('clearUpgradeTimer')(function clearUpgradeTimer(viewState: ComposeViewState) {
    if (viewState.upgradeTimer) {
        clearTimeout(viewState.upgradeTimer);
        viewState.upgradeTimer = null;
    }
});
